import { render, staticRenderFns } from "./CovByPropDepth.vue?vue&type=template&id=566753b7&"
import script from "./CovByPropDepth.vue?vue&type=script&lang=js&"
export * from "./CovByPropDepth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports